module.exports = __webpack_public_path__ + "img/big_1_39.2ff39e19.png";